import { Box } from "@mui/material";
import React from "react";
import HeroPage from "./Hero/Hero";
import About from "./About/About";
import Services from "./Services/Services";
import Solutions from "./Solutions/Solutions";
import Contact from "./Contact/Contact";

const HomePage = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <HeroPage />
      <About />
      <Services />
      <Solutions />
      {/* <Contact /> */}
    </Box>
  );
};

export default HomePage;
